export enum RequestPriority {
    Low = 'low',
    Normal = 'normal',
    High = 'high',
    Critical = 'critical',
}
